module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lxm-contact-org"
  }, [_c('div', {
    staticClass: "page"
  }, [_c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("机构信息")]), _vm._v(" "), _vm._l((_vm.rows), function(r) {
    return [_c('transition', {
      attrs: {
        "name": "lxm-content-transition",
        "mode": "out-in"
      }
    }, [(!_vm.loading) ? _c('lxm-row', {
      attrs: {
        "name": r.name
      },
      on: {
        "click": function($event) {
          _vm.rowClicked(r)
        }
      }
    }, [_vm._v(_vm._s(r.value))]) : _vm._e()], 1)]
  })], 2), _vm._v(" "), _c('contact-list', {
    attrs: {
      "orgId": _vm.orgId
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-de9170be", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-de9170be!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/Contact/Org.vue
// module id = 888
// module chunks = 0